export const buttonStyle: Object = { borderRadius: 4, padding: 2 };
export const buttonSmallStyle: Object = { borderRadius: 4, paddingLeft: 3, paddingRight: 3 };